/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { Dropdown, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import moment from 'moment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as AppConstants from '../../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import * as actionType from './store/actionTypes';
import {
  getDrugFamilyId,
  saveDrugFamily,
  getNewStc,
  getNewMfgIdData,
  createFlag,
  getDrugFamilyCompleteDetail,
  disableSaveCancel,
  updateErrorFieldList,
  detailserrorMsg,
  dispatchSearchElements,
  getExistingCorrLinkIds,
  drugFamilyDetail,
  updateActionBit,
  detailsFormValueStore,
  getContractsData,
  tabValue,
  drugSeqNum,
  getDrugRouteCodeData,
  searchDrugFamilyList,
  getAllManufacturers,
  searchDrugFamilyDetail,
  rightTableData,
  getAllManufacturerDetail,
  getManufacturer,
  deletedDrugs,
  copyNDCdata,
} from './store/actions';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../Manufacturer/store/ManufacturerAction';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
} from '../../../Display/NDC/store/action';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  removeErr,
  tabHighLigther,
  makeFormDirty,
} from '../../../../SharedModules/utilities/utilities';
import {
  SUCCESSMESSAGE_PRICE,
  NO_DRUG_RETRIEVED,
  CUSTOM_MSG_SEARCH_DRUG,
  ERR_SELECT_NDC_REMOVE,
  NDC_ALREADY_ADDED,
  DRUG_FAMILY,
  DRUG_DESCRIPTION,
  DRUG_SELECTION_ERR,
  START_DATE_REQUIRED,
  DATE_INVALID_FORMAT_ERROR,
  MFG_START_DATE_ERROR,
  START_DATE_REQUIRED_DRUG_FAMILY,
  DATE_INVALID_FORMAT_ERROR_DRUG_FAMILY,
  END_DATE_GREATER_THAN_START_DATE_DRUG_FAMILY,
  MINIMUM_START_ERROR_DRUG_FAMILY,
  WAC_FILED_ALLOW_NUMBER,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  MinDate,
  MaxDate,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  compareDatewithDefault,
  closeTab,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  MarketBasketTab,
  ContractTab,
  detailsDrugTab,
  drugManufacturerHead,
  NDCDetailTableHead,
  NDCTableHead,
} from '../DrugFamilySearch/tableHead.js';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { dispatchCellClick, selectedType } from '../../Contract/store/actions';

const DrugFamilyDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [keyValue, setKeyValue] = React.useState([]);
  const [closedContractCheck, setClosedContractCheck] = React.useState(false);
  const [detailsGridParams, setDetailsGridParams] = React.useState();
  const [disableSearchCancel, setDisableSearchCancel] = React.useState(true);
  const [openManufactureDlg, setOpenManufactureDlg] = React.useState(false);
  const [leftTableAPI, setLeftTableAPI] = React.useState();
  const [rightTableAPI, setRightTableAPI] = React.useState();
  const [selectedNDC, setSelectedNDC] = React.useState([]);
  const [removeNDC, setRemoveNDC] = React.useState([]);
  const gridHeight = '360px';
  const [showComments, setShowComments] = React.useState(false);
  const [selectedManufacture, setSelectedManufacture] = React.useState();
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [deleteNdc, setDeleteNdc] = React.useState(false);
  const [cancelView, setCancelView] = React.useState(false);
  const [saveView, setSaveView] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState('');
  const [successMsg, setSuccessMsg] = React.useState([]);
  const [comments, setComments] = React.useState([]);
  const [linkTable, setLinkTable] = React.useState('');
  const [leftFull, setLeftFull] = React.useState(false);
  const [rightFull, setRightFull] = React.useState(false);

  const [commonPopup, setCommonPopup] = React.useState(false);
  const [commonMsg, setCommonMsg] = React.useState([]);

  React.useEffect(() => {
    if (commonMsg.length > 0 && !commonPopup) {
      setCommonPopup(true);
    }
  }, [commonPopup]);

  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const drug_family_details = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.drug_family_details
  );
  const create_new_flag = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.create_new_flag
  );
  const contract_data = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.contract_data
  );
  const tab_value = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.tab_value
  );
  const drug_seq_num = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.drug_seq_num
  );
  const drug_search_list = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.drug_search_list
  );
  const drug_route_code = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.drug_route_code
  );
  const search_form_values = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.search_form_values
  );
  const all_manufacturer_data = useSelector(
    (state) =>
      state?.sharedState?.DrugFamilyDetailsReducer?.all_manufacturer_data
  );
  const errorFieldList = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.errorFieldList
  );
  const details_error_msg = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.details_error_msg
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const right_table_data = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.right_table_data
  );
  const left_table_data = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.left_table_data
  );
  const details_form_values = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.details_form_values
  );
  const update_action_bit = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.update_action_bit
  );
  const deleted_drugs = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.deleted_drugs
  );
  const dup_NDC_data = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.dup_NDC_data
  );
  const disable_btns = useSelector(
    (state) => state?.sharedState?.DrugFamilyDetailsReducer?.disable_btns
  );

  const emptySearchForm = {
    searchSelect: 'drugName',
    searchText: '',
    routeCode: '',
    manufacturer: '',
    familySeqNum: '',
  };
  const emptyDetailsForm = {
    startDt: '',
    wacPct: '',
    brandName: '',
    mfgId: '',
    specificTheraClass: '',
    newstc: '',
    newmfgId: '',
    familyName: '',
    familyDescr: '',
    endDate: '',
  };
  const [searchformValue, setSearchFormValue] = React.useState(
    search_form_values || emptySearchForm
  );
  const [detailsformValue, setDetailsFormValue] = React.useState(
    details_form_values || emptyDetailsForm
  );
  const dateRegEx = /^[0-1][0-9]{1,2}\/[0-3][0-9]{1,2}\/\d{4}$/;
  const wacRegEx = /^(\d{1,11}|\d{0,11}\.\d{1,6})$/;

  const assignValues = () => {
    return {
      startDt: '',
      wacPct: drug_family_details.wacPct || '',
      brandName: drug_family_details.brandName || '',
      mfgId: drug_family_details.mfgId || '',
      specificTheraClass: drug_family_details.specificTheraClass || '',
      familyName: drug_family_details.familyName || '',
      familyDescr: drug_family_details.familyDescr || '',
      endDate: drug_family_details.endDate || '',
      newmfgId: drug_family_details.mfgId || '',
      newstc: drug_family_details.specificTheraClass || '',
    };
  };

  const callCommentsExisting = async (value, condition) => {
    const result = await getExistingCorrLinkIds({
      corrLinkId: [value],
    });
    if (condition === 'top') setComments(result.data);
    return result;
  };

  const getMaxOrMinDate = (dates, category) => {
    if (!dates.length) return '';
    let finalDate = new Date(dates[0]);
    for (let i = 1; i < dates.length; i++) {
      const currentDate = new Date(dates[i]);
      if (category === 'max') {
        if (currentDate > finalDate) {
          finalDate = currentDate;
        }
      } else if (category === 'min') {
        if (currentDate < finalDate) {
          finalDate = currentDate;
        }
      }
    }
    return moment(finalDate).format('MM/DD/YYYY');
  };

  const clearTableErr = () => {
    setSuccessMsg([]);
    const err = removeErr(details_error_msg, [
      ERR_SELECT_NDC_REMOVE,
      NDC_ALREADY_ADDED,
      DRUG_SELECTION_ERR,
    ]);
    dispatch(detailserrorMsg(err));
    dispatch(
      updateErrorFieldList({
        ...errorFieldList,
        leftTableErr: { status: false, err: '' },
        rightTableErr: { status: false, err: '' },
      })
    );
  };

  const saveValidation = () => {
    const err = [];
    let fldErr = {};
    if (detailsformValue.familyName === '') {
      err.push(DRUG_FAMILY);
      fldErr = { ...fldErr, familyNameErr: true };
    }
    if (detailsformValue.familyDescr === '') {
      err.push(DRUG_DESCRIPTION);
      fldErr = { ...fldErr, descErr: true };
    }
    if (!detailsformValue.startDt || detailsformValue.startDt === '') {
      err.push(START_DATE_REQUIRED);
      fldErr = { ...fldErr, startDateErr: true };
    } else if (!dateRegEx.test(detailsformValue.startDt)) {
      err.push(DATE_INVALID_FORMAT_ERROR);
      fldErr = { ...fldErr, startDateFormatErr: true };
    } else if (
      !compareDatewithDefault(
        moment(detailsformValue.startDt).format('MM/DD/YYYY')
      )
    ) {
      err.push(MFG_START_DATE_ERROR);
      fldErr = { ...fldErr, startDateLessErr: true };
    }
    if (
      detailsformValue.wacPct !== '' &&
      !wacRegEx.test(detailsformValue.wacPct)
    ) {
      err.push(WAC_FILED_ALLOW_NUMBER);
      fldErr = { ...fldErr, wacPctErr: true };
    }
    if (!right_table_data.length) {
      err.push(DRUG_SELECTION_ERR);
    } else {
      const tdata = right_table_data.map((val, ind) => {
        if (!val.startDt || val.StartDt === '') {
          const msg = `${START_DATE_REQUIRED_DRUG_FAMILY} ${ind + 1}`;
          err.push(msg);
          val.startDtErr = true;
          val.starterrMsg = msg;
        } else if (val.startDtErr) {
          err.push(val.starterrMsg);
        }
        if (val.endDateErr) {
          err.push(val.enderrMsg);
        }
        return val;
      });
      dispatch(rightTableData(tdata));
    }
    dispatch(detailserrorMsg(err));
    dispatch(updateErrorFieldList(fldErr));
    if (err.length > 0) return true;
    return false;
  };

  const saveDrugDetails = async (e, close) => {
    setSaveView(false);
    setLoading(true);
    setSuccessMsg([]);
    const mfgPayload = right_table_data.map((obj) => {
      return {
        drugSeqNum: obj.drugSeqNum,
        ndc: obj.ndc,
        startDt: moment(obj.startDt).format('MM/DD/YYYY'),
      };
    });
    const stcPayload = right_table_data.map((obj) => obj.drugSeqNum);
    const mfg = await dispatch(getNewMfgIdData({ drugRequestVOs: mfgPayload }));
    const stc = await dispatch(getNewStc({ drugSeqNums: stcPayload }));
    dispatch(detailserrorMsg([]));
    dispatch(updateErrorFieldList({}));
    cancelSearch();
    const endDt = right_table_data
      .filter((obj) => obj.endDt && !obj.endDateErr)
      .map((obj) => obj.endDt);
    const savePayload = {
      drugFamily: {
        familySeqNum: drug_seq_num,
        familyName: detailsformValue.familyName,
        familyDescr: detailsformValue.familyDescr,
        mfgId: mfg?.drugFamilyNewMfgVO?.newMfgId,
        brandName: detailsformValue?.brandName,
        specificTheraClass: stc.newSTC,
        wacPct: parseFloat(detailsformValue?.wacPct),
        endDate:
          endDt.length === right_table_data.length
            ? getMaxOrMinDate(endDt, 'max')
            : '',
        lastUpdateUserId: logInUser,
      },
      savedrugFamilyDrugs: right_table_data.map((obj) => {
        return {
          familySeqNum: drug_seq_num,
          drugSeqNum: obj.drugSeqNum,
          startDt:
            obj.startDt != null ? moment(obj.startDt).format('MM/DD/YYYY') : '',
          endDt:
            obj.endDt && obj.endDt != null && obj.endDt != ''
              ? moment(obj.endDt).format('MM/DD/YYYY')
              : '',
          lastUpdateUserId: logInUser,
        };
      }),
      deletedrugFamilyDrugs: deleted_drugs.map((obj) => {
        return {
          familySeqNum: drug_seq_num,
          drugSeqNum: obj.drugSeqNum,
          startDt:
            obj.startDt != null ? moment(obj.startDt).format('MM/DD/YYYY') : '',
          endDt:
            obj.endDt && obj.endDt != null && obj.endDt != ''
              ? moment(obj.endDt).format('MM/DD/YYYY')
              : '',
          lastUpdateUserId: logInUser,
        };
      }),
    };
    const saveData = await dispatch(saveDrugFamily(savePayload));
    if (close) closeTab(AppConstants.DRUG_DETAIL_ROUTE, history);
    setLoading(false);
    if (saveData.status === '001') {
      dispatch(disableSaveCancel(true));
      makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, false);
      setSuccessMsg([SUCCESSMESSAGE_PRICE]);
      const drugData = await dispatch(
        getDrugFamilyCompleteDetail({
          familySeqNum: drug_seq_num,
        })
      );
      const { drugFamilyVO, drugFamilyDrugVO } = drugData?.drugFamilyWrapperVO;
      const dates = drugFamilyDrugVO.map((obj) => obj.startDt);
      const value = {
        ...detailsformValue,
        mfgId: drugFamilyVO.mfgId ? drugFamilyVO.mfgId : '',
        specificTheraClass: drugFamilyVO?.specificTheraClass,
        newmfgId: drugFamilyVO.mfgId ? drugFamilyVO.mfgId : '',
        newstc: drugFamilyVO?.specificTheraClass,
        endDate: drugFamilyVO?.endDate || '',
        startDt: getMaxOrMinDate(dates, 'min'),
      };
      setDetailsFormValue(value);
      dispatch(detailsFormValueStore(value));
      dispatch(drugFamilyDetail(drugFamilyVO));
      recursive(drugFamilyDrugVO, 0, []);
      dispatch(createFlag(false));
    //  setTimeout(() => setSuccessMsg([]), 5000);
    }
  };

  const clearDrugDetails = () => {
    setCancelView(false);
    dispatch(disableSaveCancel(true));
    makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, false);
    dispatch(detailserrorMsg([]));
    setSuccessMsg([]);
    dispatch(updateErrorFieldList({}));
    const dup = JSON.parse(dup_NDC_data);
    dispatch(rightTableData(dup));
    if (create_new_flag) {
      setDetailsFormValue(emptyDetailsForm);
      dispatch(detailsFormValueStore(emptyDetailsForm));
    } else {
      const updateForm = assignValues();
      const dates = dup.map((obj) => obj.startDt);
      updateForm.startDt = getMaxOrMinDate(dates, 'min');
      setDetailsFormValue(updateForm);
      dispatch(detailsFormValueStore(updateForm));
    }
    setSearchFormValue(emptySearchForm);
    dispatch(dispatchSearchElements(emptySearchForm));
    makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, false);
  };

  const handleChangeTabValue = (ev, val) => {
    dispatch(tabValue(val));
  };

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const callStcAndMfgData = async (data, showpopup, specMsg = []) => {
    const mfgPayload = data.map((obj) => {
      return {
        drugSeqNum: obj.drugSeqNum,
        ndc: obj.ndc,
        startDt:
          obj.startDt !== '' &&
          obj.startDt !== null &&
          JSON.stringify(obj.startDt) !== 'null'
            ? moment(obj.startDt).format('MM/DD/YYYY')
            : detailsformValue.startDt !== '' &&
              detailsformValue.startDt !== null
            ? moment(detailsformValue.startDt).format('MM/DD/YYYY')
            : moment().format('MM/DD/YYYY'),
      };
    });
    const stcPayload = data.map((obj) => obj.drugSeqNum);
    const mfg = await dispatch(getNewMfgIdData({ drugRequestVOs: mfgPayload }));
    const stc = await dispatch(getNewStc({ drugSeqNums: stcPayload }));
    if (mfg && stc) {
      const value = {
        ...detailsformValue,
        newmfgId: mfg?.drugFamilyNewMfgVO?.newMfgId,
        newstc: stc.newSTC,
      };
      setDetailsFormValue(value);
      dispatch(detailsFormValueStore(value));
    }
    if (showpopup) {
      let messages = [];
      if (stc && stc.newSTC === 'MULTIPLE') {
        messages.push(AppConstants.VIEW_DRUG_FAMILY_DETAIL_MGS);
      }
      if (mfg) {
        const {
          drugFamilyNewMfgVO: {
            newMfgId,
            mfgNotFoundDrugs,
            multipleMfgFoundDrugs,
          },
        } = mfg;
        if (newMfgId === 'MULTIPLE') {
          messages.push(AppConstants.MULTIPLE_MANUFACTURER_POPUP);
        }
        if (mfgNotFoundDrugs.length > 0) {
          const list = mfgNotFoundDrugs.map((obj) => obj.ndc).join(',');
          messages.push(`${AppConstants.NO_MANUFACTURER_FOUND} ${list}`);
        }
        if (multipleMfgFoundDrugs.length > 0) {
          const list = multipleMfgFoundDrugs.map((obj) => obj.ndc).join(',');
          messages.push(`${AppConstants.MULTIPLE_MFG_FOUND} ${list}`);
        }
      }
      messages = [...messages, ...specMsg];
      setCommonMsg(messages);
      setCommonPopup(true);
    }
  };

  const recursive = async (data, ind, newval) => {
    if (ind < data.length) {
      const obj = data[ind];
      const result = await getExistingCorrLinkIds({
        corrLinkId: [obj.corrLinkId],
      });
      obj.cc_COMMENTS_EXIST = result.data.length ? 1 : 0;
      newval.push(obj);
      recursive(data, ind + 1, newval);
    }
    if (ind === data.length) {
      disableManufacturerGo(newval, true);
    }
  };

  React.useEffect(() => {
    dispatch(searchDrugFamilyList());
    dispatch(
      getDrugRouteCodeData({
        codeDomainList: ['DRUG_ROUTE_CD'],
      })
    );
    if (!create_new_flag)
      callCommentsExisting(drug_family_details.corrLinkId, 'top');
  }, []);

  React.useEffect(() => {
    if (update_action_bit) {
      if (
        details_form_values.startDt &&
        !errorFieldList.startDateFormatErr &&
        !errorFieldList.startDateErr &&
        !errorFieldList.startDateLessErr &&
        right_table_data.length > 0
      ) {
        callStcAndMfgData(right_table_data, true, [
          AppConstants.ASSIGN_STARTDATE_SUCCESS,
        ]);
        let err = [];
        right_table_data.map((obj) => {
          if (!obj.startDt || obj.startDt === '') {
            obj.startDt = detailsformValue.startDt;
            obj.startDtErr = false;
            if (obj.starterrMsg) err.push(obj.starterrMsg);
            obj.starterrMsg = '';
          }
          return obj;
        });
        err = removeErr(details_error_msg, err);
        dispatch(detailserrorMsg(err));
        dispatch(rightTableData(right_table_data));
        dispatch(disableSaveCancel(false));
        makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, true);
        if (detailsGridParams) detailsGridParams.api.refreshCells();
      }
      if (!detailsformValue.startDt) {
        dispatch(
          detailserrorMsg([
            ...new Set([...details_error_msg, START_DATE_REQUIRED]),
          ])
        );
        dispatch(
          updateErrorFieldList({ ...errorFieldList, startDateErr: true })
        );
      }
      dispatch(updateActionBit(false));
    }
  }, [update_action_bit]);

  React.useEffect(() => {
    setLoading(false);
  }, [left_table_data]);

  React.useEffect(() => {
    if (drug_seq_num) {
      dispatch(
        getContractsData({
          familySeqNum: drug_seq_num,
          todayDt: moment().format('MM/DD/YYYY'),
        })
      );
    }
  }, [drug_seq_num]);

  React.useEffect(() => {
    if (detailsGridParams && localStorage.getItem('updatedetails')) {
      detailsGridParams.api.redrawRows();
      localStorage.removeItem('updatedetails');
    }
  }, [right_table_data]);

  React.useEffect(() => {
    if (create_new_flag === true) {
      dispatch(tabValue('one'));
      dispatch(getDrugFamilyId());
      dispatch(copyNDCdata('[]'));
      dispatch(detailsFormValueStore(emptyDetailsForm));
    } else if (localStorage.getItem('updatedetails')) {
      dispatch(tabValue('two'));
      dispatch(copyNDCdata('[]'));
      dispatch(drugSeqNum(drug_family_details.familySeqNum));
      const updateForm = assignValues();
      const dates = right_table_data.map((obj) => obj.startDt);
      updateForm.startDt = getMaxOrMinDate(dates, 'min');
      setDetailsFormValue(updateForm);
      dispatch(detailsFormValueStore(updateForm));
      recursive(right_table_data, 0, []);
    }
  }, [create_new_flag]);

  React.useEffect(() => {
    if (details_error_msg && details_error_msg.length > 0) {
      tabHighLigther(AppConstants.DRUG_DETAIL_ROUTE, true);
    } else {
      tabHighLigther(AppConstants.DRUG_DETAIL_ROUTE, false);
    }
  }, [details_error_msg]);

  React.useEffect(() => {
    const data = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      data &&
      data.length > 0 &&
      data.filter((x) => {
        return x.navTo === AppConstants.DRUG_DETAIL_ROUTE && x.isFormSave;
      }).length > 0
    ) {
      const list = data.map((obj) => {
        if (
          obj.navTo === AppConstants.DRUG_DETAIL_ROUTE &&
          obj.isFormDirty === true
        ) {
          obj.isFormSave = false;
          if (!saveValidation()) {
            saveDrugDetails(null, true);
          }
        }
        return obj;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(list));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const goToNdcDetails = async (ndc, drugname) => {
    const response = await getNDCDetails([{ ndc: ndc, drugName: drugname }]);
    if (response) {
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(setCurrentNDCDetailsIndex(1));
      dispatch(setCurrentNDCDetailsSelected(response[0], 'All'));
      dispatch(setNDCDetails([{ ndc: ndc, drugName: drugname }]));
      redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
    }
  };

  const goToManufacturerDetails = async (value) => {
    const split = value.split('-');
    const checkManuf = dispatch(
      getManufacturer({
        labelerCode: split[0],
      })
    );
    checkManuf
      .then((response) => {
        if (response.data?.data) {
          const checkDetail = dispatch(
            getAllManufacturerDetail({
              showAllInd: false,
              mfgId: response.data?.data,
            })
          );
          checkDetail
            .then((res) => {
              if (res.data?.status == '001') {
                const tempObj = {
                  mfgId: res.data?.data?.mfgVO?.mfgId,
                  mfgName: res.data?.data?.mfgVO?.mfgName,
                  mfgTypeCd: res.data?.data?.mfgVO?.mfgTypeCd,
                  updateManufacturer: true,
                  name: res.data?.data?.mfgVO?.name,
                };
                dispatch(setSelectManufacturerData({}));
                dispatch(fetchAllManufacturerDetail(null));
                dispatch(getContactDetails(null));
                dispatch(maintainLabelerListData({}));
                dispatch(setMaintainManufacturerTab({}));
                const updateTabs =
                  JSON.parse(localStorage.getItem('tabItemsData')) === null
                    ? []
                    : JSON.parse(localStorage.getItem('tabItemsData'));
                if (
                  updateTabs.findIndex(
                    (item) => item.navTo === '/manufacturer-detail'
                  ) === -1
                ) {
                  updateTabs.push({
                    navTo: '/manufacturer-detail',
                    value: 'Maintain Manufacturer',
                  });
                  localStorage.setItem(
                    'tabItemsData',
                    JSON.stringify(updateTabs)
                  );
                }
                const result = dispatch(setSelectManufacturerData(tempObj));

                if (result && Object.keys(result).length > 0) {
                  history.push({ pathname: '/manufacturer-detail' });
                }
              }
            })
            .catch((err) => {});
        }
      })
      .catch((err) => {});
  };

  const frameworkComponents = {
    FullNameRender: (cellInfo) => {
      let name = '';
      if (cellInfo?.colDef?.headerName === 'Contract ID') {
        name = cellInfo.data.contractName;
      }
      const goToContract = async () => {
        // redirectURLLink('/contract', 'Contract Search', history);
        dispatch(dispatchCellClick(true));
        dispatch(selectedType('C'));
        searchContractState.contractType = 'onSelect';
        searchContractState.selectedContractType = 'contractId';
        searchContractState.selectedRowData = cellInfo?.data?.contractSeqNum;
        searchContractState.selectedContractId = cellInfo?.data?.contractSeqNum;
        searchContractState.rebateProgramCode = cellInfo?.data?.rebateProgramCd;
        searchContractState.searchContractDate = cellInfo?.data?.startDt
          ? moment(new Date(cellInfo?.data?.startDt)).format('MM/DD/YYYY')
          : null;
        redirectURLLink(
          '/createContract',
          'Maintain Contract',
          history,
          dispatch
        );
      };
      if (name && name.length > 20) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>
              <a
                href="javascript:void()"
                onClick={() => {
                  goToContract();
                }}
              >
                {name}
              </a>
            </div>
          </OverlayTrigger>
        );
      }
      return (
        <div>
          <a
            href="javascript:void()"
            onClick={() => {
              goToContract();
            }}
          >
            {name}
          </a>
        </div>
      );
    },
  };

  const NDCframeworkComponents = {
    FullNameRender: (cellInfo) => {
      let name = '';
      if (cellInfo?.colDef?.headerName === 'NDC') {
        name = cellInfo.data.ndc;
        return (
          <div>
            <a
              href="javascript:void()"
              onClick={() => {
                goToNdcDetails(cellInfo.data.ndc, cellInfo.data.drugName);
              }}
            >
              {name}
            </a>
          </div>
        );
      }
      if (cellInfo?.colDef?.headerName === 'Drug Name') {
        name = cellInfo.data.drugName;
        if (name && name.length > 20) {
          return (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
            >
              <div>{name && `${name}`}</div>
            </OverlayTrigger>
          );
        }
      }
      return <div>{name}</div>;
    },
  };

  const commentsData = (status, table, corrLinkId) => {
    setShowComments(status);
    setLinkTable(table);
    setCorrLinkId(corrLinkId);
  };

  const detailsframeworkComponents = {
    IconButtonCell: (cellInfo) => {
      return (
        <div className="tdCell frr-icon-btn-group d-flex justify-content-start">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
          >
            {!cellInfo.data.addedNew ? (
              <Button
                onClick={() =>
                  commentsData(
                    true,
                    'DRUG_FAMILY_DRUG',
                    cellInfo.data.corrLinkId
                  )
                }
                variant="text"
              >
                <img
                  alt="comment"
                  src={
                    cellInfo.data.cc_COMMENTS_EXIST
                      ? CommentVisibleIcon
                      : CommentIcon
                  }
                  style={{ width: '19px', height: '19px' }}
                />
              </Button>
            ) : (
              <Button
                disabled
                type="button"
                aria-label="comment"
                className="th-ic comment-ic frr-disabled-comment-btn "
                variant="text"
              >
                <img
                  alt="comment"
                  src={CommentIcon}
                  style={{ width: '19px', height: '19px' }}
                />
              </Button>
            )}
          </OverlayTrigger>
          <Dropdown className="icon-dropdown-container float-right">
            <Dropdown.Toggle
              className="icon-dropdown"
              aria-label="Action Dropdown"
            >
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="action-tooltip">Actions</Tooltip>}
              >
                <SVGComponent iconName="Icon-export" />
              </OverlayTrigger>
            </Dropdown.Toggle>
            <Dropdown.Menu className="export_dropdown h-auto">
              <Dropdown.Item
                onClick={() => {
                  setDeleteNdc(cellInfo.data.ndc);
                  setDeleteModal(true);
                }}
              >
                Delete
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() => {
                  goToNdcDetails(cellInfo.data.ndc, cellInfo.data.drugName);
                }}
              >
                Go To NDC
              </Dropdown.Item>
              <Dropdown.Item
                disabled={cellInfo.data.disablego}
                onClick={() => {
                  goToManufacturerDetails(cellInfo.data.ndc);
                }}
              >
                Go To Manufacturer
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      );
    },
    FullNameRender: (cellInfo) => {
      let name = '';
      if (cellInfo?.colDef?.headerName === 'NDC') {
        name = cellInfo.data.ndc;
      }
      if (cellInfo?.colDef?.headerName === 'Drug Name') {
        name = cellInfo.data.drugName;
      }

      if (name && name.length > 20) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name && `${name}`}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    DatePickerBoxRender: (cellInfo) => {
      const right_table_data = useSelector(
        (state) =>
          state?.sharedState?.DrugFamilyDetailsReducer?.right_table_data
      );
      const details_error_msg = useSelector(
        (state) =>
          state?.sharedState?.DrugFamilyDetailsReducer?.details_error_msg
      );
      const startDateChange = (data, val) => {
        makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, true);
        dispatch(disableSaveCancel(false));
        let tabledata = right_table_data;
        let err = details_error_msg;
        let errmsg;
        let rmv = false;
        if (!val || val === '') {
          errmsg = `${START_DATE_REQUIRED_DRUG_FAMILY} ${
            data.node.rowIndex + 1
          }`;
        } else if (
          val === 'Invalid Date' ||
          !dateRegEx.test(moment(val).format('MM/DD/YYYY'))
        ) {
          errmsg = `${DATE_INVALID_FORMAT_ERROR_DRUG_FAMILY} ${
            data.node.rowIndex + 1
          }`;
        } else if (!compareDatewithDefault(moment(val).format('MM/DD/YYYY'))) {
          errmsg = `${MINIMUM_START_ERROR_DRUG_FAMILY} ${
            data.node.rowIndex + 1
          }`;
        } else if (
          data.data.endDt &&
          !data.data.endDateErr &&
          Date.parse(data.data.endDt) - Date.parse(val) < 0
        ) {
          errmsg = `${END_DATE_GREATER_THAN_START_DATE_DRUG_FAMILY} ${
            data.node.rowIndex + 1
          }`;
          rmv = true;
        }
        tabledata = right_table_data.map((obj) => {
          if (obj.drugSeqNum === data.data.drugSeqNum) {
            if (errmsg) {
              obj.startDt = val;
              obj.startDtErr = true;
              obj.starterrMsg = errmsg;
              err = [...new Set([...err, obj.starterrMsg])];
            } else {
              obj.startDt = val;
              obj.startDtErr = false;
              err =
                obj.starterrMsg && obj.starterrMsg !== obj.enderrMsg
                  ? removeErr(err, [obj.starterrMsg])
                  : err;
              obj.starterrMsg = '';
              if (
                data.data.endDt &&
                data.data.endDt !== null &&
                JSON.stringify(data.data.endDt) !== 'null' &&
                Date.parse(data.data.endDt) - Date.parse(val) >= 0
              ) {
                obj.endDateErr = false;
                err = removeErr(err, [obj.enderrMsg]);
                obj.enderrMsg = '';
              }
            }
          }
          return obj;
        });
        dispatch(detailserrorMsg(err));
        dispatch(rightTableData(tabledata));
        data.api.refreshCells();
      };
      const endDateChange = (data, val) => {
        makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, true);
        dispatch(disableSaveCancel(false));
        let tabledata = right_table_data;
        let err = details_error_msg;
        let errmsg;
        let rmv = false;
        if (
          val === 'Invalid Date' ||
          (val !== '' && !dateRegEx.test(moment(val).format('MM/DD/YYYY')))
        ) {
          errmsg = `${DATE_INVALID_FORMAT_ERROR_DRUG_FAMILY} ${
            data.node.rowIndex + 1
          }`;
        } else if (
          data.data.startDt &&
          !data.data.startDtErr &&
          Date.parse(val) - Date.parse(data.data.startDt) < 0
        ) {
          errmsg = `${END_DATE_GREATER_THAN_START_DATE_DRUG_FAMILY} ${
            data.node.rowIndex + 1
          }`;
          rmv = true;
        }
        tabledata = right_table_data.map((obj) => {
          if (obj.drugSeqNum === data.data.drugSeqNum) {
            if (errmsg) {
              obj.endDt = val;
              obj.endDateErr = true;
              obj.enderrMsg = errmsg;
              err = [...new Set([...err, obj.enderrMsg])];
            } else {
              obj.endDt = val;
              obj.endDateErr = false;
              err =
                obj.enderrMsg && obj.starterrMsg !== obj.enderrMsg
                  ? removeErr(err, [obj.enderrMsg])
                  : err;
              obj.enderrMsg = '';
              if (
                data.data.startDt &&
                data.data.startDt !== null &&
                JSON.stringify(data.data.startDt) !== 'null' &&
                Date.parse(val) - Date.parse(data.data.startDt) >= 0
              ) {
                obj.startDateErr = false;
                err = removeErr(err, [obj.starterrMsg]);
                obj.starterrMsg = '';
              }
            }
          }
          return obj;
        });
        dispatch(detailserrorMsg(err));
        dispatch(rightTableData(tabledata));
        data.api.refreshCells();
      };

      return (
        <div className="frr-remove-formClt-mt-label textLabel_hide">
          {cellInfo.column.colId === 'startDt' ? (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                required
                className={
                  cellInfo.data?.startDtErr
                    ? 'td-active-cell tBill-validate'
                    : ''
                }
                label="Start Date"
                id={`startDt-${cellInfo.rowIndex}-${cellInfo.column.colId}`}
                format="MM/dd/yyyy"
                mask="__/__/____"
                minDate={MinDate}
                maxDate={MaxDate}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: false,
                  autoFill: false,
                  id: `startDt-${cellInfo.rowIndex}-${cellInfo.column.colId}`,
                  'aria-label': 'Select Start Date',
                }}
                KeyboardButtonProps={{
                  'aria-label': 'Select Start Date',
                }}
                onKeyDown={async (e) => {
                  if (e.keyCode == 67) {
                    // copy date
                    await window.navigator?.clipboard.writeText(
                      e?.target?.value
                    );
                  }
                }}
                placeholder="mm/dd/yyyy"
                onChange={(e) => {
                  makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, true);
                  dispatch(disableSaveCancel(false));
                  if (
                    e !== null &&
                    JSON.stringify(e) !== 'Invalid Date' &&
                    JSON.stringify(e) !== 'null'
                  )
                    startDateChange(cellInfo, e);
                }}
                onBlur={(e) => startDateChange(cellInfo, e.target.value)}
                value={cellInfo.value || null}
                helperText={null}
                error={null}
              />
            </MuiPickersUtilsProvider>
          ) : (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                required
                className={
                  cellInfo.data?.endDateErr
                    ? 'td-active-cell tBill-validate'
                    : ''
                }
                label="End Date"
                id={`endDt-${cellInfo.rowIndex}-${cellInfo.column.colId}`}
                format="MM/dd/yyyy"
                mask="__/__/____"
                minDate={new Date(cellInfo.data?.startDt)}
                maxDate={MaxDate}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: false,
                  autoFill: false,
                  id: `endDt-${cellInfo.rowIndex}-${cellInfo.column.colId}`,
                  'aria-label': 'Select End Date',
                }}
                KeyboardButtonProps={{
                  'aria-label': 'Select Start Date',
                }}
                onKeyDown={async (e) => {
                  if (e.keyCode == 67) {
                    // copy date
                    await window.navigator?.clipboard.writeText(
                      e?.target?.value
                    );
                  }
                }}
                placeholder="mm/dd/yyyy"
                onChange={(e) => {
                  makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, true);
                  dispatch(disableSaveCancel(false));
                  if (
                    e !== null &&
                    JSON.stringify(e) !== 'Invalid Date' &&
                    JSON.stringify(e) !== 'null'
                  )
                    endDateChange(cellInfo, e);
                }}
                onBlur={(e) => endDateChange(cellInfo, e.target.value)}
                value={cellInfo.value || null}
                helperText={null}
                error={null}
              />
            </MuiPickersUtilsProvider>
          )}
        </div>
      );
    },
  };

  const closedContractDisplayChange = (event) => {
    setClosedContractCheck(event.target.checked);
    if (event.target.checked) {
      dispatch(
        getContractsData({
          familySeqNum: drug_seq_num,
          todayDt: null,
        })
      );
    } else {
      dispatch(
        getContractsData({
          familySeqNum: drug_seq_num,
          todayDt: moment().format('MM/DD/YYYY'),
        })
      );
    }
  };

  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      FAMILY_SEQ_NUM: drug_seq_num,
    });
  };

  const onDetailsGridReady = (params) => {
    setDetailsGridParams(params);
  };

  const onSearchFormChange = (field, value) => {
    setSuccessMsg([]);
    setDisableSearchCancel(false);
    dispatch(disableSaveCancel(false));
    makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, true);
    const upadtedVal = {
      ...searchformValue,
      [field]: value,
    };
    setSearchFormValue(upadtedVal);
    dispatch(dispatchSearchElements(upadtedVal));
  };

  const onSelectManufacturer = (val) => {
    const [selectedRows] = val.api.getSelectedRows();
    setSelectedManufacture(selectedRows);
  };

  const onSelectionChangedLeft = (val) => {
    const selectedRows = val.api.getSelectedRows();
    setLeftTableAPI(val.api);
    setSelectedNDC(selectedRows);
  };

  const onSelectionChangedRight = (val) => {
    const selectedRows = val.api.getSelectedRows();
    setRightTableAPI(val.api);
    setRemoveNDC(selectedRows);
  };

  const moveToLeft = () => {
    if (removeNDC.length === 0) {
      const err = removeErr(details_error_msg, [NDC_ALREADY_ADDED]);
      dispatch(
        detailserrorMsg([
          ...new Set([...details_error_msg, ERR_SELECT_NDC_REMOVE]),
        ])
      );
      dispatch(
        updateErrorFieldList({
          ...errorFieldList,
          leftTableErr: { status: false, err: '' },
          rightTableErr: { status: true, err: ERR_SELECT_NDC_REMOVE },
        })
      );
    } else {
      const rmNDC = removeNDC.map((obj) => obj.ndc);
      const results = right_table_data.filter(
        (obj) => rmNDC.indexOf(obj.ndc) === -1
      );
      const deleted = right_table_data.filter(
        (obj) => rmNDC.indexOf(obj.ndc) !== -1 && !rmNDC.addedNew
      );
      dispatch(deletedDrugs([...deleted_drugs, ...deleted]));
      setRemoveNDC([]);
      clearTableErr();
      dispatch(disableSaveCancel(false));
      makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, true);
      if (results.length === 0) {
        const updateform = {
          ...detailsformValue,
          newmfgId: '',
          newstc: '',
        };
        setDetailsFormValue(updateform);
        dispatch(detailsFormValueStore(updateform));
      } else callStcAndMfgData(results, false);
      dispatch(rightTableData(results));
    }
  };

  const moveToRight = (moveAll) => {
    if (selectedNDC.length === 0 && !moveAll) {
      const err = removeErr(details_error_msg, [NDC_ALREADY_ADDED]);
      dispatch(
        detailserrorMsg([
          ...new Set([...details_error_msg, ERR_SELECT_NDC_REMOVE]),
        ])
      );
      dispatch(
        updateErrorFieldList({
          ...errorFieldList,
          leftTableErr: { status: true, err: ERR_SELECT_NDC_REMOVE },
          rightTableErr: { status: false, err: '' },
        })
      );
    } else {
      if (leftTableAPI) leftTableAPI.deselectAll();
      const rlist = right_table_data?.map((obj) => obj.ndc);
      if (rlist?.length > 0) {
        let indexes;
        if (moveAll)
          indexes = left_table_data.map((val) => rlist?.indexOf(val.ndc));
        else indexes = selectedNDC.map((val) => rlist?.indexOf(val.ndc));
        const mapping = [...new Set(indexes)];
        if (mapping.length > 1 || (mapping.length === 1 && mapping[0] !== -1)) {
          const err = removeErr(details_error_msg, [ERR_SELECT_NDC_REMOVE]);
          dispatch(detailserrorMsg([...new Set([...err, NDC_ALREADY_ADDED])]));
          dispatch(
            updateErrorFieldList({
              ...errorFieldList,
              leftTableErr: { status: true, err: NDC_ALREADY_ADDED },
              rightTableErr: { status: false, err: '' },
            })
          );
        } else {
          addRight(moveAll);
        }
      } else {
        addRight(moveAll);
      }
    }
  };

  const addRight = (moveAll) => {
    clearTableErr();
    dispatch(disableSaveCancel(false));
    makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, true);
    let record;
    if (moveAll) record = left_table_data;
    else record = selectedNDC;
    const list = record.map((obj) => {
      obj.addedNew = true;
      obj.startDt = '';
      obj.startDtErr = false;
      obj.starterrMsg = '';
      obj.endDt = '';
      obj.endDateErr = false;
      return obj;
    });
    const data = [...right_table_data, ...list];
    callStcAndMfgData(data, true);
    disableManufacturerGo(data);
  };

  const disableManufacturerGo = async (data, copy) => {
    if (data.length) {
      const mfgPayload = data.map((obj) => {
        return {
          drugSeqNum: obj.drugSeqNum,
          ndc: obj.ndc,
          startDt: obj.startDt
            ? moment(obj.startDt).format('MM/DD/YYYY')
            : moment().format('MM/DD/YYYY'),
        };
      });
      const mfg = await dispatch(
        getNewMfgIdData({ drugRequestVOs: mfgPayload })
      );
      const ndc = mfg?.drugFamilyNewMfgVO?.mfgNotFoundDrugs.map((ob) => ob.ndc);
      data = data.map((ob) => {
        if (ndc.indexOf(ob.ndc) !== -1) ob.disablego = true;
        return ob;
      });
      dispatch(rightTableData(data));
      if (copy) dispatch(copyNDCdata(JSON.stringify(data)));
      if (detailsGridParams) detailsGridParams.api.redrawRows();
    }
  };

  const searchDrug = () => {
    setSuccessMsg([]);
    setDisableSearchCancel(false);
    if (searchformValue.searchText === '') {
      dispatch({ type: actionType.MAINTAIN_LEFT_TABLE_DATA, payload: [] });
      const getVal =
        searchformValue.searchSelect == 'drugName'
          ? 'Drug Name value'
          : searchformValue.searchSelect == 'genericcode'
          ? 'Generic Code value'
          : searchformValue.searchSelect == 'stc'
          ? 'Specific Therapeutic Class value'
          : 'GCN Sequence Number value';
      const drugErr = `${CUSTOM_MSG_SEARCH_DRUG + getVal}.`;
      const err = removeErr(details_error_msg, [
        NO_DRUG_RETRIEVED,
        errorFieldList?.drugSearchErr?.err,
      ]);
      dispatch(detailserrorMsg([...new Set([...err, drugErr])]));
      dispatch(
        updateErrorFieldList({
          ...errorFieldList,
          drugSearchErr: { err: drugErr, status: true },
        })
      );
    } else {
      setLoading(true);
      const payload = {};
      payload[searchformValue.searchSelect] = searchformValue.searchText;
      const err = removeErr(details_error_msg, [
        NO_DRUG_RETRIEVED,
        errorFieldList?.drugSearchErr?.err,
        ERR_SELECT_NDC_REMOVE,
        NDC_ALREADY_ADDED,
        DRUG_SELECTION_ERR,
      ]);
      dispatch(detailserrorMsg(err));
      dispatch(
        updateErrorFieldList({
          ...errorFieldList,
          drugSearchErr: { err: '', status: false },
          leftTableErr: { status: false, err: '' },
          rightTableErr: { status: false, err: '' },
        })
      );
      if (searchformValue.routeCode !== '') {
        payload.drugRouteCd = searchformValue.routeCode;
      }
      if (searchformValue.manufacturer != '') {
        payload.mfgId = searchformValue.manufacturer;
        payload.adDate = true
          ? moment().format('MM/DD/YYYY')
          : moment(new Date()).format('MM/DD/YYYY');
      }
      dispatch(searchDrugFamilyDetail(payload, details_error_msg));
    }
  };

  const cancelSearch = () => {
    dispatch(dispatchSearchElements(emptySearchForm));
    setSearchFormValue(emptySearchForm);
    setSuccessMsg([]);
    setDisableSearchCancel(true);
    dispatch({
      type: actionType.MAINTAIN_LEFT_TABLE_DATA,
      payload: [],
    });
    clearTableErr();
    const err = removeErr(details_error_msg, [
      errorFieldList?.drugSearchErr?.err,
    ]);
    dispatch(detailserrorMsg(err));
    dispatch(
      updateErrorFieldList({
        ...errorFieldList,
        drugSearchErr: { err: '', status: false },
      })
    );
  };

  const startDateHandler = (val) => {
      setSuccessMsg([]);
    dispatch(disableSaveCancel(false));
    makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, true);
    let err = removeErr(details_error_msg, [
      START_DATE_REQUIRED,
      DATE_INVALID_FORMAT_ERROR,
      MFG_START_DATE_ERROR,
    ]);
    let fldErr = {
      ...errorFieldList,
      startDateFormatErr: false,
      startDateErr: false,
      startDateLessErr: false,
    };
    if (!val || val === '') {
      err = [...new Set([...err, START_DATE_REQUIRED])];
      fldErr = { ...fldErr, startDateErr: true };
    } else if (!dateRegEx.test(moment(val).format('MM/DD/YYYY'))) {
      err = [...new Set([...err, DATE_INVALID_FORMAT_ERROR])];
      fldErr = { ...fldErr, startDateFormatErr: true };
    } else if (!compareDatewithDefault(moment(val).format('MM/DD/YYYY'))) {
      err = [...new Set([...err, MFG_START_DATE_ERROR])];
      fldErr = { ...fldErr, startDateLessErr: true };
    } else {
      const upadtedVal = {
        ...detailsformValue,
        startDt: moment(val).format('MM/DD/YYYY'),
      };
      setDetailsFormValue(upadtedVal);
      dispatch(detailsFormValueStore(upadtedVal));
    }
    dispatch(detailserrorMsg(err));
    dispatch(updateErrorFieldList(fldErr));
  };

  const onDetailsFormChange = (field, value) => {
    setSuccessMsg([]);
    dispatch(disableSaveCancel(false));
    makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, true);
    const upadtedVal = {
      ...detailsformValue,
      [field]: value,
    };
    setDetailsFormValue(upadtedVal);
    dispatch(detailsFormValueStore(upadtedVal));
    if (
      field === 'startDt' &&
      JSON.stringify(value) !== 'Invalid Date' &&
      JSON.stringify(value) !== 'null' &&
      value !== null
    )
      startDateHandler(value);
  };

  const onBlurDetailsForm = (field, value) => {
    let err = details_error_msg;
    let fldErr = errorFieldList;
    switch (field) {
      case 'familyName':
        if (value === '') {
          err = [...new Set([...details_error_msg, DRUG_FAMILY])];
          fldErr = { ...errorFieldList, familyNameErr: true };
        } else {
          err = removeErr(details_error_msg, [DRUG_FAMILY]);
          fldErr = { ...errorFieldList, familyNameErr: false };
        }
        break;
      case 'familyDescr':
        if (value === '') {
          err = [...new Set([...details_error_msg, DRUG_DESCRIPTION])];
          fldErr = { ...errorFieldList, descErr: true };
        } else {
          err = removeErr(details_error_msg, [DRUG_DESCRIPTION]);
          fldErr = { ...errorFieldList, descErr: false };
        }
        break;
      case 'startDt':
        startDateHandler(value.target.value);
        return;
    }
    dispatch(detailserrorMsg(err));
    dispatch(updateErrorFieldList(fldErr));
  };

  const commonPopupFn = () => {
    setCommonPopup(false);
    if (commonMsg.length >= 1) {
      const msg = commonMsg;
      msg.shift();
      setCommonMsg(msg);
    }
  };

  const deleteNDCFromTable = () => {
    setDeleteModal(false);
    dispatch(disableSaveCancel(false));
    makeFormDirty(AppConstants.DRUG_DETAIL_ROUTE, true);
    const results = right_table_data.filter((obj) => obj.ndc !== deleteNdc);
    const deleted = right_table_data.filter(
      (obj) => obj.ndc === deleteNdc && !obj.addedNew
    );
    const tex = right_table_data.filter((ob) => ob.ndc === deleteNdc);
    let err = [tex?.[0]?.starterrMsg, tex?.[0]?.enderrMsg];
    err = removeErr(details_error_msg, err);
    dispatch(detailserrorMsg(err));
    if (results.length > 0) {
      callStcAndMfgData(results, true);
    } else {
      const updateform = {
        ...detailsformValue,
        newmfgId: '',
        newstc: '',
      };
      setDetailsFormValue(updateform);
      dispatch(detailsFormValueStore(updateform));
    }
    dispatch(rightTableData(results));
    dispatch(deletedDrugs([...deleted_drugs, ...deleted]));
    setDeleteNdc('');
  };

  return (
    <div className="tabs-container" data-testid="drugFamilyDetails">
      <Spinner load={loading} />
      <CustomSeparator parent1="Maintain" parent2="View Drug Family Details" />
      <DisplaySuccessMessages successMessages={successMsg} />
      <ErrorMessages errorMessages={details_error_msg} />
      <div className="custom-check">
        {!fullScreenView && !leftFull && !rightFull && (
          <>
            <fieldset className="custom-fieldset">
              <div className="form-wrapper form-wrapper-col-4 ">
                <div className="mui-custom-form input-md frr-text-right">
                  <TextField
                    id="familySeqNum"
                    label="Family ID"
                    InputLabelProps={{ shrink: true }}
                    value={drug_seq_num}
                    disabled
                  />
                </div>
                <div className="mui-custom-form input-md mandate-fields">
                  <TextField
                    required
                    id="familyName"
                    label="Family Name"
                    inputProps={{ maxLength: 120 }}
                    InputLabelProps={{ shrink: true }}
                    value={detailsformValue.familyName}
                    // autoFocus
                    onBlur={(e) =>
                      onBlurDetailsForm('familyName', e.target.value)
                    }
                    onChange={(e) =>
                      onDetailsFormChange('familyName', e.target.value)
                    }
                    helperText={
                      errorFieldList?.familyNameErr ? DRUG_FAMILY : null
                    }
                    error={errorFieldList?.familyNameErr}
                  />
                </div>
                <div className="mui-custom-form input-md mandate-fields">
                  <TextField
                    required
                    id="familyDescr"
                    label="Description"
                    inputProps={{ maxLength: 225 }}
                    InputLabelProps={{ shrink: true }}
                    value={detailsformValue.familyDescr}
                    onBlur={(e) =>
                      onBlurDetailsForm('familyDescr', e.target.value)
                    }
                    onChange={(e) =>
                      onDetailsFormChange('familyDescr', e.target.value)
                    }
                    helperText={
                      errorFieldList?.descErr ? DRUG_DESCRIPTION : null
                    }
                    error={errorFieldList?.descErr}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="enddate"
                    label="End Date"
                    InputLabelProps={{ shrink: true }}
                    value={detailsformValue.endDate}
                    disabled
                  />
                </div>
              </div>
              <div className="comment-sec pl-3 mt-2">
                Comments {''}{' '}
                <img
                  role="button"
                  alt="comment"
                  tabIndex="0"
                  src={
                    !create_new_flag && comments?.length > 0
                      ? CommentVisibleIcon
                      : CommentIcon
                  }
                  onClick={() => {
                    if (!create_new_flag) {
                      commentsData(
                        true,
                        'DRUG_FAMILY',
                        drug_family_details.corrLinkId
                      );
                    }
                  }}
                />
              </div>
            </fieldset>
            <div className="btn-wrapper mb-2">
              <div className="float-right mt-2 hide-on-print">
                <Button
                  className="btn btn-success btn-search"
                  onClick={() => {
                    if (!saveValidation()) {
                      setSaveView(true);
                    }
                  }}
                  disabled={disable_btns}
                >
                  <SVGComponent iconName="Icon-awesome-save" /> Save
                </Button>
                <Button
                  className="btn btn-cancel"
                  onClick={() => setCancelView(true)}
                  disabled={disable_btns}
                >
                  <SVGComponent iconName="Icon-cancel" /> Cancel
                </Button>
              </div>
              <div className="clearfix" />
            </div>
          </>
        )}
        {!fullScreenView && !leftFull && !rightFull && (
          <div className="tabs-wrapper mb-4">
            <AppBar
              position="static"
              sx={{ width: '100%' }}
              style={{ borderBottom: '1px solid #c9c8c5' }}
            >
              <Tabs
                value={tab_value}
                onChange={(ev, val) => {
                  handleChangeTabValue(ev, val);
                  const err = removeErr(details_error_msg, [
                    ERR_SELECT_NDC_REMOVE,
                    NDC_ALREADY_ADDED,
                  ]);
                  dispatch(detailserrorMsg(err));
                  dispatch(
                    updateErrorFieldList({
                      ...errorFieldList,
                      leftTableErr: { status: false, err: '' },
                      rightTableErr: { status: false, err: '' },
                    })
                  );
                }}
              >
                <Tab
                  style={{ textTransform: 'capitalize' }}
                  value="one"
                  label="Drugs"
                  tabIndex={0}
                />
                {details_error_msg?.some(
                  (msg) =>
                    [
                      errorFieldList?.drugSearchErr?.err,
                      ERR_SELECT_NDC_REMOVE,
                      NDC_ALREADY_ADDED,
                    ].indexOf(msg) !== -1
                ) && <span className="tab-error">!</span>}
                <Tab
                  style={{ textTransform: 'capitalize' }}
                  value="two"
                  label="Details"
                  tabIndex={0}
                />
                {(errorFieldList?.startDateErr ||
                  errorFieldList?.startDateFormatErr ||
                  errorFieldList?.startDateLessErr ||
                  errorFieldList.wacPctErr) && (
                  <span className="tab-error">!</span>
                )}
                <Tab
                  style={{ textTransform: 'capitalize' }}
                  value="three"
                  label="Market Basket"
                  tabIndex={0}
                />
                <Tab
                  style={{ textTransform: 'capitalize' }}
                  value="four"
                  label="Contract"
                  tabIndex={0}
                />
              </Tabs>
            </AppBar>
          </div>
        )}
        <div className="clearfix" />
        {tab_value === 'one' && (
          <>
            {!leftFull && !rightFull && (
              <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
                <legend className="same-font-family">Search Criteria</legend>
                <div className="form-wrapper form-wrapper-col-4">
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="selectdrug"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ id: 'selectdrug' }}
                      className="frr-display-hidden-label"
                      select
                      value={searchformValue.searchSelect}
                      label="select"
                      onChange={(e) =>
                        onSearchFormChange('searchSelect', e.target.value)
                      }
                    >
                      {drug_search_list &&
                        drug_search_list.map((item) => (
                          <MenuItem key={item.id} value={item.value}>
                            {item.name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </div>
                  <div className="mui-custom-form input-md mandate-fields">
                    <TextField
                      InputLabelProps={{ shrink: true }}
                      id="drugfield"
                      inputProps={{ id: 'drugfield' }}
                      className="frr-display-hidden-label"
                      label="drugfield"
                      value={searchformValue.searchText}
                      onChange={(e) =>
                        onSearchFormChange('searchText', e.target.value)
                      }
                      helperText={
                        errorFieldList?.drugSearchErr?.status
                          ? errorFieldList?.drugSearchErr?.err
                          : null
                      }
                      error={errorFieldList?.drugSearchErr?.status}
                    />
                  </div>
                  <div className="mui-custom-form input-md ">
                    <TextField
                      id="DrugRouteCode"
                      label="Drug Route Code"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ id: 'DrugRouteCode' }}
                      select
                      value={searchformValue.routeCode ?? ''}
                      SelectProps={{ displayEmpty: true }}
                      onChange={(e) =>
                        onSearchFormChange('routeCode', e.target.value)
                      }
                    >
                      <MenuItem value="" />
                      {drug_route_code &&
                        drug_route_code.map((item, index) => {
                          return (
                            <MenuItem
                              key={index}
                              value={item.codeValueID.codeValue}
                            >
                              {item.codeValueID.codeValue}&nbsp;:&nbsp;
                              {item.longDescription}
                            </MenuItem>
                          );
                        })}
                    </TextField>
                  </div>
                  <div style={{ marginTop: '18px' }}>
                    <div className="float-right mt-2 hide-on-print">
                      <Button
                        data-testid="searchDrugBtn"
                        className="btn btn-success btn-search searchdrug"
                        onClick={searchDrug}
                      >
                        <SVGComponent iconName="Icon-search" /> Search
                      </Button>
                      <Button
                        className="btn btn-cancel ml-3"
                        onClick={cancelSearch}
                        disabled={disableSearchCancel}
                      >
                        <SVGComponent iconName="Icon-cancel-drugtab" /> Cancel
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="form-wrapper form-wrapper-col-4">
                  <div className="mui-custom-form pl-2">
                    <TextField
                      label="Manufacturer"
                      id="Manufacturer"
                      inputProps={{ id: 'Manufacturer' }}
                      InputLabelProps={{ shrink: true }}
                      value={searchformValue?.manufacturer}
                      onChange={(e) =>
                        onSearchFormChange('manufacturer', e.target.value)
                      }
                      disabled
                    />
                  </div>
                  <div style={{ marginTop: '26px' }}>
                    <Button
                      className="btn btn-success btn-search btn btn-primary"
                      onClick={() => {
                        setOpenManufactureDlg(true);
                        dispatch(getAllManufacturers());
                      }}
                    >
                      <SVGComponent iconName="Icon-accept" /> Select
                    </Button>
                  </div>
                </div>
              </fieldset>
            )}
            <div className="row d-inline-flex w-100 pl-4">
              {!rightFull && (
                <div style={!leftFull ? { width: '47%' } : { width: '100%' }}>
                  {errorFieldList?.leftTableErr?.status && (
                    <ErrorMessages
                      errorMessages={[errorFieldList?.leftTableErr?.err]}
                    />
                  )}
                  <TableGrid
                    data-testid="leftGrid"
                    rowData={left_table_data}
                    gridHeight={leftFull ? '70vh' : 360}
                    handleFullScreenViewClick={() => setLeftFull(!leftFull)}
                    columnDefs={NDCDetailTableHead}
                    rowSelection="multiple"
                    navigateToNextCell={navigateToNextCell}
                    // tabToNextCell={tabToNextCell}
                    onSelectionChanged={onSelectionChangedLeft}
                    enterMovesDown
                    suppressCellFocus
                    exportFile
                    fileName="NDCLeftsTableData"
                    onCellFocused={onCellFocused}
                    frameworkComponents={NDCframeworkComponents}
                    helpMessage={AppConstants.CANDIDATE_DRUGS}
                  />
                </div>
              )}
              {!leftFull && !rightFull && (
                <div className="ndcsTableSection task_request_claim">
                  <div className="ndcTableBtn">
                    <Button
                      className="btn-primary"
                      onClick={() => moveToRight(false)}
                      data-testid="move-left-to-right-btn"
                      aria-label="single data forward"
                      tabIndex={0}
                    >
                      <i
                        className="fa fa-light fa-caret-right"
                        aria-hidden="true"
                      />
                    </Button>
                    <Button
                      className="btn-primary"
                      onClick={() => moveToRight(true)}
                      data-testid="move-all-left-to-right-btn"
                      aria-label="All data forward"
                      tabIndex={0}
                    >
                      <i
                        className="fa fa-light fa-forward"
                        aria-hidden="true"
                      />
                    </Button>
                    <Button
                      className="btn-primary"
                      onClick={() => {
                        dispatch(rightTableData([]));
                        clearTableErr();
                      }}
                      tabIndex={0}
                      aria-label="All data backward"
                      data-testid="move-all-right-to-left-btn"
                    >
                      <i
                        className="fa fa-light fa-backward"
                        aria-hidden="true"
                      />
                    </Button>
                    <Button
                      className="btn-primary"
                      onClick={moveToLeft}
                      data-testid="move-right-to-left-btn"
                      aria-label="single data backward"
                      tabIndex={0}
                    >
                      <i
                        className="fa fa-light fa-caret-left"
                        aria-hidden="true"
                      />
                    </Button>
                  </div>
                </div>
              )}
              {!leftFull && (
                <div style={!rightFull ? { width: '47%' } : { width: '100%' }}>
                  {errorFieldList?.rightTableErr?.status && (
                    <ErrorMessages
                      errorMessages={[errorFieldList?.rightTableErr?.err]}
                    />
                  )}
                  <TableGrid
                    data-testid="rightgrid"
                    rowData={right_table_data}
                    gridHeight={rightFull ? '70vh' : 360}
                    handleFullScreenViewClick={() => setRightFull(!rightFull)}
                    columnDefs={NDCTableHead}
                    rowSelection="single"
                    exportFile
                    fileName="NDCRightTableData"
                    onSelectionChanged={onSelectionChangedRight}
                    helpMessage={AppConstants.SELECTED_DRUGS}
                    frameworkComponents={detailsframeworkComponents}
                  />
                </div>
              )}
            </div>
          </>
        )}
        {tab_value === 'two' && (
          <>
            {!fullScreenView && (
              <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
                <div className="form-wrapper justify-content-between frr-mui-customfields-v2">
                  <div className="mui-custom-form input-md frr-field-md-1 mandate-fields">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        required
                        id="begin_date_net_association_bp_tab"
                        data-testid="start-date"
                        label="Start Date"
                        format="MM/dd/yyyy"
                        mask="__/__/____"
                        className="mandate-fields"
                        minDate={MinDate}
                        maxDate={MaxDate}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          readOnly: false,
                          autoFill: false,
                        }}
                        placeholder="mm/dd/yyyy"
                        value={
                          detailsformValue.startDt === ''
                            ? null
                            : detailsformValue.startDt
                        }
                        onChange={(val) => onDetailsFormChange('startDt', val)}
                        onBlur={(val) => onBlurDetailsForm('startDt', val)}
                        onKeyDown={async (e) => {
                          if (e.keyCode == 67) {
                            // copy date
                            await window.navigator?.clipboard.writeText(
                              e?.target?.value
                            );
                          }
                        }}
                        helperText={
                          errorFieldList?.startDateErr
                            ? START_DATE_REQUIRED
                            : errorFieldList?.startDateFormatErr
                            ? DATE_INVALID_FORMAT_ERROR
                            : errorFieldList?.startDateLessErr
                            ? MFG_START_DATE_ERROR
                            : null
                        }
                        error={
                          errorFieldList?.startDateErr ||
                          errorFieldList?.startDateFormatErr ||
                          errorFieldList?.startDateLessErr
                        }
                        KeyboardButtonProps={{
                          'aria-label': 'Start date',
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className="mui-custom-form input-md frr-field-md-1">
                    <TextField
                      label="WAC Override Percent"
                      id="wacOverridePercent"
                      className="mandate-fields"
                      InputLabelProps={{ shrink: true }}
                      value={detailsformValue.wacPct}
                      inputProps={{ maxLength: 12, id: 'wacOverridePercent' }}
                      name="wacOverridePercent"
                      onChange={(e) =>
                        onDetailsFormChange('wacPct', e.target.value)
                      }
                      onBlur={(e) => {
                        if (
                          wacRegEx.test(e.target.value) ||
                          e.target.value == ''
                        ) {
                          const err = removeErr(details_error_msg, [
                            WAC_FILED_ALLOW_NUMBER,
                          ]);
                          dispatch(detailserrorMsg(err));
                          dispatch(
                            updateErrorFieldList({
                              ...errorFieldList,
                              wacPctErr: false,
                            })
                          );
                        } else {
                          dispatch(
                            detailserrorMsg([
                              ...new Set([
                                ...details_error_msg,
                                WAC_FILED_ALLOW_NUMBER,
                              ]),
                            ])
                          );
                          dispatch(
                            updateErrorFieldList({
                              ...errorFieldList,
                              wacPctErr: true,
                            })
                          );
                        }
                      }}
                      helperText={
                        errorFieldList?.wacPctErr
                          ? WAC_FILED_ALLOW_NUMBER
                          : null
                      }
                      error={errorFieldList?.wacPctErr}
                    />
                  </div>
                  <div className="mui-custom-form input-md frr-field-md-1">
                    <TextField
                      id="brandname"
                      label="Brand Name"
                      inputProps={{ id: 'brandname', maxLength: 30 }}
                      InputLabelProps={{ shrink: true }}
                      value={detailsformValue.brandName}
                      name="brandName"
                      onChange={(e) =>
                        onDetailsFormChange('brandName', e.target.value)
                      }
                      onBlur={(e) => {}}
                      error=""
                    />
                  </div>
                  <div className="line-break-div" />
                  <div className="mui-custom-form input-md frr-field-md-1">
                    <TextField
                      id="maufacturerid"
                      label="Manufacturer ID"
                      inputProps={{ id: 'maufacturerid' }}
                      InputLabelProps={{ shrink: true }}
                      value={detailsformValue.mfgId}
                      name="manufacturerId"
                      disabled
                    />
                  </div>
                  <div className="mui-custom-form input-md frr-field-md-1">
                    <TextField
                      label="New Manufacturer ID"
                      id="newmanufacturerid"
                      inputProps={{ id: 'newmanufacturerid' }}
                      InputLabelProps={{ shrink: true }}
                      value={detailsformValue.newmfgId}
                      name="newManufId"
                      disabled
                    />
                  </div>
                  <div className="mui-custom-form input-md frr-field-md-1">
                    <TextField
                      label="New STC"
                      id="newstc"
                      inputProps={{ id: 'newstc' }}
                      InputLabelProps={{ shrink: true }}
                      value={detailsformValue.newstc}
                      name="newStc"
                      disabled
                    />
                  </div>
                  <div className="line-break-div" />
                  <div className="mui-custom-form input-md frr-field-md-1">
                    <TextField
                      label="Specific Therapeutic Class"
                      id="specifictherapeutic"
                      inputProps={{ id: 'specifictherapeutic' }}
                      InputLabelProps={{ shrink: true }}
                      value={detailsformValue.specificTheraClass}
                      name="specificTheraCls"
                      disabled
                    />
                  </div>
                </div>
              </fieldset>
            )}
            <TableGrid
              rowData={right_table_data}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              columnDefs={detailsDrugTab}
              gridCall={onDetailsGridReady}
              gridHeight={fullScreenView ? '70vh' : 355}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              exportWithOtherOption
              fileName="DrugDetails"
              frameworkComponents={detailsframeworkComponents}
              handleViewHistory={handleViewHistory}
            />
          </>
        )}
        {tab_value === 'three' && (
          <>
            <div id="frr-disabled-table">
              <TableGrid
                rowData={[]}
                gridHeight={fullScreenView ? '70vh' : 355}
                columnDefs={MarketBasketTab}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                navigateToNextCell={navigateToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
              />
            </div>
            <div className="form-wrapper">
              <div className="mui-custom-form input-md">
                <div className="frr-sub-checkbox frr-no-wrap">
                  <FormControlLabel
                    control={
                      <Checkbox style={{ margin: '5px' }} color="primary" />
                    }
                    label="Current Market Baskets Only"
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {tab_value === 'four' && (
          <>
            <TableGrid
              rowData={contract_data || []}
              gridHeight={fullScreenView ? '70vh' : 355}
              columnDefs={ContractTab}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              exportFile
              fileName="Contracts"
              frameworkComponents={frameworkComponents}
            />
            <div className="form-wrapper">
              <div className="mui-custom-form input-md">
                <div className="sub-checkbox frr-no-wrap">
                  <FormControlLabel
                    control={
                      <Checkbox style={{ margin: '5px' }} color="primary" />
                    }
                    label="Include Closed Contracts"
                    checked={closedContractCheck}
                    value={closedContractCheck ? 1 : 0}
                    onChange={closedContractDisplayChange}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {!leftFull && !rightFull && !fullScreenView && (
          <div className="float-right">
            <div className="btn-wrapper">
              <Button
                className="btn btn-success btn-search bottomd"
                data-testid="nosave"
                onClick={() => {
                  if (!saveValidation()) {
                    setSaveView(true);
                  }
                }}
                disabled={disable_btns}
              >
                <SVGComponent iconName="Icon-awesome-save" /> Save
              </Button>
              <Button
                className="btn btn-cancel bottomd"
                onClick={() => setCancelView(true)}
                disabled={disable_btns}
              >
                <SVGComponent iconName="Icon-cancel" /> Cancel
              </Button>
            </div>
          </div>
        )}
      </div>
      <CommonModal
        open={openManufactureDlg}
        viewAction
        viewHeader
        onOk={() => {
          if (selectedManufacture) {
            onSearchFormChange('manufacturer', selectedManufacture.mfgId);
            setOpenManufactureDlg(false);
          }
        }}
        okTitle="Ok"
        onClose={() => setOpenManufactureDlg(false)}
        closeTitle="Cancel"
        modalTitle={AppConstants.MANUFACTURER_SELECT_MSG}
        childrenComponent={
          <TableGrid
            rowData={all_manufacturer_data || []}
            columnDefs={drugManufacturerHead}
            gridHeight={AppConstants.GRID_HEIGHT}
            onSelect={(e) => onSelectManufacturer(e)}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            fileName="ManufacturerTableData"
            childPopup
          />
        }
      />
      {commonMsg.length ? (
        <CommonModal
          open={commonPopup}
          className="dialog-420"
          viewAction
          viewHeader
          data-testid="commonPopupFn"
          onOk={commonPopupFn}
          okTitle="Ok"
          onClose={commonPopupFn}
          modalTitle={AppConstants.VIEW_DRUG_FAMILY_DETAIL}
          childrenComponent={commonMsg?.[0] || ''}
        />
      ) : null}
      <SaveCancelPopup
        open={deleteModal}
        data-test="cancelPopup"
        title="Delete"
        onConfim={(e) => deleteNDCFromTable()}
        onCancel={(e) => setDeleteModal(false)}
        moduleName={`selected NDC ${deleteNdc} drug`}
      />
      <SaveCancelPopup
        open={cancelView}
        title="Cancel"
        data-testid="reset-button-uc"
        onConfim={clearDrugDetails}
        onCancel={(e) => setCancelView(false)}
        moduleName=""
      />
      <SaveCancelPopup
        open={saveView}
        title="Save"
        data-testid="save-api-uc"
        onConfim={saveDrugDetails}
        onCancel={(e) => setSaveView(false)}
        moduleName=""
      />
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="DRUG_FAMILY"
          keyValue={keyValue}
          //columnNames='START_DT,END_DT'
        />
      )}
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={async () => {
            const result = await getExistingCorrLinkIds({
              corrLinkId: [corrLinkId],
            });
            if (linkTable === 'DRUG_FAMILY') {
              setComments(result.data);
            } else {
              const newVal = right_table_data.map((obj) => {
                if (obj.corrLinkId === corrLinkId)
                  obj.cc_COMMENTS_EXIST = result.data.length ? 1 : 0;
                return obj;
              });
              dispatch(rightTableData(newVal));
              detailsGridParams.api.redrawRows();
            }
            commentsData(false, '', '');
          }}
          linkTableName={linkTable}
          corrLinkId={corrLinkId}
        />
      ) : null}
    </div>
  );
};

export default DrugFamilyDetails;
